import { render, staticRenderFns } from "./BookingnoBookingDetails.vue?vue&type=template&id=2175f09d&scoped=true"
import script from "./BookingnoBookingDetails.vue?vue&type=script&lang=js"
export * from "./BookingnoBookingDetails.vue?vue&type=script&lang=js"
import style0 from "./BookingnoBookingDetails.vue?vue&type=style&index=0&id=2175f09d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2175f09d",
  null
  
)

export default component.exports